import { useState, useEffect } from 'react';
import { InputLabel, MenuItem, FormControl, Select } from '@mui/material';
import { API_GET, DBRequest, useConfig } from '../../../api/api';
import ExoAvatar from '../../exo/ExoAvatar';
import TypeSkeleton from './TypeSkeleton';
import FormHelperText from '../FormHelperText';
import { useTranslation } from 'react-i18next';
import useFetch from '../../../api/useFetch';
import CategoryIcon from '@mui/icons-material/Category';

export const TypeProjectPreset = ({
  updateValidationOnChange,
  dataCollection,
  errors,
  field,
  size,
}) => {
  const { t } = useTranslation();
  const { apiData } = useFetch(`project-presets`);

  const NO_PRESET = 'none';

  // If there is no preset selected and there are presets available, set the value to "No Preset" (null) to avoid validation errors for required field
  useEffect(() => {
    if (!apiData?.data) return;
    if (dataCollection[field.key] !== undefined) return;
    if (apiData.data.length === 0) {
      updateValidationOnChange(field.key, { id: null });
    }
  }, [apiData]);

  function handleChangeSelect(e) {
    if (e.target.value === NO_PRESET) {
      updateValidationOnChange(field.key, { id: null });
      return;
    }
    const selectedUser = apiData.data.filter(
      (obj) => obj.id === e.target.value,
    )[0];
    updateValidationOnChange(field.key, selectedUser);
  }

  return (
    <FormControl fullWidth size={size}>
      {!apiData ? (
        <TypeSkeleton size={size} />
      ) : (
        <>
          <InputLabel id="userId-select">{field.label}</InputLabel>
          <Select
            labelId="userId-select"
            value={
              dataCollection[field.key] === undefined
                ? ''
                : (dataCollection[field.key]?.id ?? NO_PRESET)
            }
            label={field.label}
            onChange={handleChangeSelect}
            sx={{
              '& .MuiSelect-select': {
                display: 'flex',
                justifyContent: 'start',
                alignItems: 'center',
                flexDirection: 'row',
                gap: '8px',
                padding: '0px 32px 0px 14px',
                height: size == 'small' ? '40px!important' : '53px!important',
              },
            }}
          >
            <MenuItem
              value={NO_PRESET}
              className="flex flex-row gap-2 justify-start items-center"
            >
              {t('No Preset')}
            </MenuItem>
            {apiData.data.map((element) => (
              <MenuItem
                key={'company-' + element.id}
                value={element.id}
                className="flex flex-row gap-2 justify-start items-center"
              >
                <ExoAvatar
                  picture={element.icon?.temporaryUrl}
                  size="40px"
                  type="company"
                  icon={<CategoryIcon />}
                />
                {element.title}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText />
        </>
      )}
    </FormControl>
  );
};
